import React from 'react';
import Tile from "./Tile";
import TileGroup from "./TileGroup";

function PrimaryKeys(props) {
  const calc = props.calc;
  return (
    <TileGroup>
      <Tile onClick={() => calc("c")}>C</Tile>
      <Tile onClick={() => calc("ce")}>CE</Tile>
      <Tile onClick={() => calc("div")}>÷</Tile>
      <Tile onClick={() => calc("mult")}>x</Tile>
      <Tile onClick={() => calc("addNumber", 1)}>1</Tile>
      <Tile onClick={() => calc("addNumber", 2)}>2</Tile>
      <Tile onClick={() => calc("addNumber", 3)}>3</Tile>
      <Tile onClick={() => calc("minus") }>-</Tile>
      <Tile onClick={() => calc("addNumber", 4)}>4</Tile>
      <Tile onClick={() => calc("addNumber", 5)}>5</Tile>
      <Tile onClick={() => calc("addNumber", 6)}>6</Tile>
      <Tile onClick={() => calc("plus")}>+</Tile>
      <Tile onClick={() => calc("addNumber", 7)}>7</Tile>
      <Tile onClick={() => calc("addNumber", 8)}>8</Tile>
      <Tile onClick={() => calc("addNumber", 9)}>9</Tile>
      <Tile onClick={() => calc("pct")}>%</Tile>
      <Tile onClick={() => calc("addNumber", 0)}>0</Tile>
      <Tile onClick={() => calc("addDecimal")} className="pb-4">.</Tile>
      <Tile onClick={() => calc("negate")}><sup>+</sup>/<sub>-</sub></Tile>
      <Tile onClick={() => calc("equal")} theme={true}>=</Tile>
    </TileGroup>
  );
}

export default PrimaryKeys;



// WEBPACK FOOTER //
// ./src/MDCCalc/PrimaryKeys.js